
(function(){
    emailjs.init("59h6d-yr-w8h2AoFl");
})();

if (document.getElementById('contact-form')) {
    document.getElementById('contact-form').addEventListener('submit', function(event) {
        event.preventDefault(); // Evita recargar la página

        const button = this.querySelector('button');
        const loader = this.querySelector('.loader');
        const notification = document.getElementById('notification');

        // Ocultar el botón con transición
        button.style.height = '0';
        button.style.padding = '0';
        button.style.margin = '0';

        // Mostrar el loader después de la transición del botón
        button.addEventListener('transitionend', function() {
            loader.style.display = 'block';
        }, { once: true });

        // Enviar el formulario usando EmailJS
        emailjs.sendForm('service_fm6m7hb', 'template_k7p9dgf', this)
            .then(function() {
                // Ocultar loader
                loader.style.display = 'none';
                // Mostrar notificación de éxito
                document.getElementById('notification-text').textContent = '¡Mensaje enviado correctamente!';
                const progressBar = notification.querySelector('.progress-bar');
                progressBar.style.animation = 'none';
                setTimeout(() => {
                    progressBar.style.animation = 'shrink 10s linear forwards';
                }, 10);
                notification.classList.add('success', 'show');
                // Limpiar el formulario
                document.getElementById('contact-form').reset();
                // Restaurar el botón
                button.style.height = '';
                button.style.padding = '';
                button.style.margin = '';
                // Ocultar notificación después de 10 segundos
                setTimeout(() => {
                    notification.classList.remove('show', 'success', 'error');
                }, 10000);
            }, function(error) {
                // Ocultar loader
                loader.style.display = 'none';
                // Mostrar notificación de error
                document.getElementById('notification-text').textContent = 'Error al enviar: ' + JSON.stringify(error);
                const progressBar = notification.querySelector('.progress-bar');
                progressBar.style.animation = 'none';
                setTimeout(() => {
                    progressBar.style.animation = 'shrink 10s linear forwards';
                }, 10);
                notification.classList.add('error', 'show');
                // Limpiar el formulario (opcional en error, pero por consistencia)
                // document.getElementById('contact-form').reset();
                // Restaurar el botón
                button.style.height = '';
                button.style.padding = '';
                button.style.margin = '';
                // Ocultar notificación después de 10 segundos
                setTimeout(() => {
                    notification.classList.remove('show', 'success', 'error');
                }, 10000);
            });
    });
}